import React from 'react'

export default function PageTitle({ name })
{
    return (
        <div className="pageTitle mb-2">
            <div className="container">
                <h1 className='display-1'>{name}</h1>
            </div>
        </div>
    )
}
